import React from "react";

import styled from "styled-components";

import { ReactComponent as Icon } from "assets/icons/benefitIcon.svg";

type Props = {
  isActive?: boolean;
  disabled?: boolean;
} & any;

export function BenefitsIcon({ isActive, disabled, ...rest }: Props) {
  return <StyledIcon $isActive={isActive} $disabled={disabled} {...rest} />;
}
const StyledIcon = styled(Icon)<{ $isActive?: boolean; $disabled?: boolean }>`
  path {
    fill: ${({ theme, $isActive, $disabled }) =>
      $isActive
        ? theme.palette.purpleDark
        : $disabled
          ? theme.palette.neutralLight
          : theme.palette.black};
  }
`;
